import { useState, useEffect } from 'react'
import apiFetch from '@wordpress/api-fetch'

const Categories = (props) => {
  const [data, setData] = useState(null)

  useEffect(() => {
    apiFetch({
      path: `${import.meta.env.VITE_SITE_URL}/wp-json/wp/v2/categories/${props.id}`,
    }).then((res) => {
      setData(res)
    })
  }, [])

  return (
    <>
      <li>
        <a href={data && '/news-list/?cat=' + data.id}>{data && data.name}</a>
      </li>
      <style jsx>{`
        a {
          border: 2px solid #2964b6;
          border-radius: 24px;
          padding: 0 20px;
          text-align: center;
          font: normal normal normal 18px/43px Noto Sans JP;
          color: #2964b6;
        }
      `}</style>
    </>
  )
}

export default Categories
